var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "caret_left",
    "data-name": "caret left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10573",
    "data-name": "Path 10573",
    d: "M19.7,25.4,10.3,16l9.4-9.4",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    "data-name": "Rectangle 1673",
    width: 32,
    height: 32,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/caret_left.c8860a37dcc0e790c31f25e531ca0b87.svg";
export { ForwardRef as ReactComponent };